import { IKeyStringDict } from "@/types/GlobalTypes";

//Todo: arrange & group the other languages like English
const EN: IKeyStringDict = {
	"language_code": "en",

	"txt_language": "Language",

	"txt_info": "Info",
	"txt_userid": "User ID",
	"txt_balance": "Balance",
	"txt_online_users": "Online Users",
	"txt_user": "Users",
	"txt_online": "Online",
	"txt_multitable": "MULTI TABLE",
	"txt_exit": "EXIT",

	"txt_tap_fullscreen": "Tap on this button to go fullscreen",
	"txt_lost_connection_server": "Connection with server has lost, please refresh your browser.",
	"txt_no_how_to_play": "No how to play available for this game.",
	"txt_no_data_available": "There is no data available.",

	// Game Categories
	"txt_all_games": "ALL GAMES",
	"txt_fast-tables_games": "FAST TABLE",
	"txt_favorites": "FAVORITES",
	"txt_categories": "CATEGORIES",
	"txt_dice_games": "DICE GAMES",
	"txt_ball_games": "BALL GAMES",
	"txt_casino_games": "CASINO GAMES",
	"txt_other_games": "OTHER GAMES",

	// Translated Game Names
	"txt_game_name_m6": "24Dspin",
	"txt_game_name_m7": "Oglok",
	"txt_game_name_m8": "Dice 6",
	"txt_game_name_m10": "Head Tail",
	"txt_game_name_m11": "Red White",
	"txt_game_name_m13": "Billiards",
	"txt_game_name_m14": "Poker Dice",
	"txt_game_name_m16": "Gong Ball",
	"txt_game_name_m19": "Suwit",
	"txt_game_name_m20": "Monopoly",
	"txt_game_name_m21": "Monopoly World Cup",
	"txt_game_name_m22": "Baccarat",
	"txt_game_name_m23": "Dragon & Tiger",
	"txt_game_name_m24": "NiuNiu",
	"txt_game_name_m25": "FanTan",
	"txt_game_name_m27": "Shio Fights",
	"txt_game_name_m28": "IDN 4 Stand",
	"txt_game_name_m30": "5D",
	"txt_game_name_m32": "SamGong",
	"txt_game_name_m33": "Gong Ball Jitu",
	"txt_game_name_m34": "HILO",
	"txt_game_name_m35": "48D",
	"txt_game_name_m36": "36D",
	"txt_game_name_p6": "24D",
	"txt_game_name_p7": "Roulette",
	"txt_game_name_p9": "12D",
	"txt_game_name_p12": "Sicbo[Dice]",
	"txt_game_name_m17": "Toto Macau",
	"txt_game_name_m37": "Bingo Sicbo",
	"txt_game_name_m38": "Bingo Baccarat",
	"txt_game_name_m38b": "Bingo Baccarat 2",
	"txt_game_name_m39": "Duel Dice",
	"txt_game_name_m40": "Xoc Dia",
	"txt_game_name_m42": "Pinball",
	"txt_game_name_m50": "Toto Singapore",
	"txt_game_name_m51": "Toto Macau 5D",
	"txt_game_name_toto": "IDN Lotto",

	// Special Game Names
	"txt_game_name_m26": "Race Ball",
	"txt_game_name_m29": "3D Shio",
	"txt_game_name_m31": "Sicbo Ball - Fast",
	"txt_game_name_p7b": "Roulette 2 - Fast Table",

	// Lobby-related strings
	"txt_bet_closed": "BET CLOSED",
	"txt_roadmap": "ROADMAP",
	"txt_history": "HISTORY",
	"txt_statistics": "STATISTICS",
	"txt_statistics_first": "STATISTICS 1ST BALL",
	"txt_show_all_roadmap": "Show all the Roadmap",
	"txt_show_all_history": "Show all the History",
	"txt_play_now": "PLAY NOW",
	"txt_new_game_badge": "NEW",
	"txt_history_result": "History Result",
	"txt_history_win": "History Win",
	"txt_how_to_play": "How to Play",
	"txt_full_screen": "Fullscreen",

	"txt_total_bet": "Total Bet",

	//Popups
	// "txt_mobile_how_to_play": "How To Play",
	// "txt_mobile_statistics": "STATISTICS",
	// "txt_mobile_min_max": "MIN\nMAX",

	"txt_transaction": "Transaction",
	"txt_news": "News",
	"txt_settings": "Settings",
	"txt_promotions": "Promotions",
	"txt_new_game": "New Games",
	"txt_new_features": "New Features",
	"txt_bonus_history": "Bonus History",
	"txt_memo": "Memo",
	"txt_referral": "Referral",
	"txt_periode": "Period",
	"txt_number": "Number",
	"txt_back": "Back",
	"txt_back_to_lobby_message": "Are you sure you want to go back to Lobby?",
	"txt_yes": "Yes",
	"txt_no": "No",

	//Transaction & Result History Popup
	"txt_transaction_history": "Transaction History",
	"txt_result_history": "Result History",
	"txt_number_pagination": "NO.",
	"txt_date": "Date",
	"txt_status": "Status",
	"txt_debit": "Debit",
	"txt_credit": "Credit",
	"txt_win": "Win",
	"txt_won": "Won",
	"txt_lose": "Lose",
	"txt_buy": "Buy",
	"txt_refund": "Refund",
	"txt_bet": "Bet",
	"txt_guess": "Guess",
	"txt_prize": "Prize",
	"txt_discount": "Discount",
	"txt_x_win": "X-Win",
	"txt_correction": "Correction",

	"txt_total_win": "Total Win",
	"txt_total": "Total",
	"txt_type": "Type",
	"txt_amount": "Amount",

	"txt_touch_to_close": "Touch here to close",

	"txt_all_odd": "All Odd",
	"txt_all_even": "All Even",
	"txt_all_low": "All Low",
	"txt_all_high": "All High",

	// Game Controllers
	"txt_clear": "Clear",
	"txt_undo": "Undo",
	"txt_rebet": "Rebet",
	"txt_submit": "Submit",

	// Game Table Details
	"txt_table_name": "Table Name",
	"txt_bet_limit": "Bet Limit",
	"txt_min_number": "Min. Main Bet",
	"txt_max_number": "Max. Main Bet",
	"txt_min_50": "Min 50-50",
	"txt_max_50": "Max 50-50",

	"txt_table_information": "Table Information",
	"txt_toggle_streaming": "Toggle Streaming",

	// Timer-related strings
	"txt_wait_next_round": "Wait for the Next Round",
	"txt_place_bet": "Place Your Bets",
	"txt_bet_close_in": "Bet closing in",

	// Video Off Notice
	"txt_video_is_off_desktop_message": "Video is off\nGo to settings to turn on",
	"txt_video_is_off_mobile_message": "Video is off\nTap to turn on",
	"txt_loading_video": "Loading video...",

	// Game-related strings
	"txt_odd_even": "Odd-Even",
	"txt_odd": "Odd",
	"txt_even": "Even",
	"txt_small_big": "Small-Big",
	"txt_small": "Small",
	"txt_big": "Big",
	"txt_detail": "Detail",
	"txt_red": "Red",
	"txt_blue": "Blue",
	"txt_black": "Black",
	"txt_white": "White",
	"txt_head": "Head",
	"txt_tail": "Tail",
	"txt_banker": "Banker",
	"txt_player": "Player",
	"txt_result": "Result",

	"txt_any_double": "Any Double",
	"txt_any_triple": "Any Triple",
	"txt_triple": "Triple",
	
	"txt_one": "One",
	"txt_two": "Two",
	"txt_three": "Three",
	"txt_four": "Four",
	"txt_five": "Five",
	"txt_six": "Six",
	"txt_seven": "Seven",
	"txt_eight": "Eight",
	"txt_nine": "Nine",
	"txt_ten": "Ten",

	//Billiards
	"txt_balls_passed_line": "Balls Passed Line",
	"txt_balls": "ball(s)",

	//Sicbo Dice
	"txt_on_one_dice": "ON ONE DICE",
	"txt_on_two_dice": "ON TWO DICE",
	"txt_on_three_dice": "ON THREE DICE",

	//Oglok
	"txt_shrimp": "Shrimp",
	"txt_chicken": "Chicken",
	"txt_jug": "Jug",
	"txt_crab": "Crab",
	"txt_fish": "Fish",

	// "txt_bet_translate_m10": ["2 Heads 1 Tail", "Head", "Left", "Right", "Tail", "2 Tails 1 Head", "Coin 1 Head", "Coin 1 Tail", "Coin 2 Head", "Coin 2 Tail", "Coin 3 Head", "Coin 3 Tail", "Head", "Tail"],
	// "txt_bet_translate_m11": ["Red", "White", "JP"],
	// "txt_bet_translate_m19": ["Scissors", "Stone", "Paper", "Thumb", "Index Finger", "Pinky", "Row 1", "Row 2", "Row 3", "Column 1", "Column 2", "Column 3"],
	// "txt_bet_translate_m14": ["2 Pairs", "3 of a Kind", "INC Straight", "FLUSH", "Full House", "Straight", "4 of a Kind", "INC Straight Flush", "Straight Flush", "5 of a Kind", "Black", "Red", "Odd", "Even", "Big", "Small", "1-1", "2-2", "3-3", "4-4", "5-5", "6-6"],

	// Poker Dice
	"txt_2_pairs": "2 Pairs",
	"txt_3_of_a_kind": "3 of a Kind",
	"txt_inc_straight": "Inc. Straight",
	"txt_flush": "Flush",
	"txt_full_house": "Full House",
	"txt_straight": "Straight",
	"txt_4_of_a_kind": "4 of a Kind",
	"txt_inc_straight_flush": "Inc. Straight Flush",
	"txt_straight_flush": "Straight Flush",
	"txt_5_of_a_kind": "5 of a Kind",

	//General Games with Lines & Rows
	"txt_line": "Line",
	"txt_row": "Row",

	"txt_1st_line": "Line 1",
	"txt_2nd_line": "Line 2",
	"txt_3rd_line": "Line 3",
	"txt_4th_line": "Line 4",
	"txt_5th_line": "Line 5",
	"txt_6th_line": "Line 6",
	"txt_7th_line": "Line 7",
	"txt_8th_line": "Line 8",
	"txt_9th_line": "Line 9",
	"txt_10th_line": "Line 10",
	"txt_1st_row": "Row 1",
	"txt_2nd_row": "Row 2",
	"txt_3rd_row": "Row 3",
	"txt_4th_row": "Row 4",
	"txt_2_to_1": "2 TO 1",
	"txt_1st_2nd_line": "Line 1 & 2",
	"txt_2nd_3rd_line": "Line 2 & 3",
	"txt_3rd_4th_line": "Line 3 & 4",
	"txt_4th_5th_line": "Line 4 & 5",
	"txt_5th_6th_line": "Line 5 & 6",
	"txt_1st_line_2nd_line": "Row 1 & 2",
	"txt_3rd_line_4th_line": "Row 3 & 4",
	"txt_1_to_18": "1-18",
	"txt_19_to_36": "19-36",

	//Head/Tail
	"txt_left": "Left",
	"txt_right": "Right",
	"txt_key": "Key",
	"txt_coin": "Coin",

	//Red/White
	"txt_jackpot": "JP",

	//Gong Ball
	"txt_pictures": "Pictures",

	//Monopoly
	"txt_square": "SQUARE",
	"txt_circle": "CIRCLE",
	"txt_others": "OTHERS",

	//Baccarat
	"txt_either_pair": "Either Pair",
	"txt_player_pair": "Player Pair",
	"txt_perfect_pair": "Perfect Pair",
	"txt_banker_pair": "Banker Pair",
	"txt_tie": "Tie",
	"txt_tie_on": "Tie On",

	//Sicbo Fast
	"txt_dice": "Dice",

	//V2 & V4 Games
	"txt_shoe": "Shoe",
	"txt_round_id": "Round ID",
	"txt_new_shoe_message": "New shoe in progress\nPlease wait",
	"txt_less_bet": "Less Bet",
	"txt_more_bet": "More Bet",

	//Settings
	"txt_sounds": "Sounds",
	"txt_music": "Music",
	"txt_auto_confirm_bet": "Auto Confirm Bet",
	"txt_auto_rebet": "Auto Rebet",
	"txt_video": "Video",
	"txt_rotation": "Rotation",
	"txt_enable_rotation": "Enable Rotation",

	//Suwit
	"txt_batu": "Stone",
	"txt_gunting": "Scissors",
	"txt_kertas": "Paper",
	"txt_jempol": "Thumb",
	"txt_telunjuk": "Index Finger",
	"txt_kelingking": "Pinky",

	//Shio Fights
	"txt_rat": "rat",
	"txt_ox": "ox",
	"txt_tiger": "tiger",
	"txt_rabbit": "rabbit",
	"txt_dragon": "dragon",
	"txt_snake": "snake",
	"txt_horse": "horse",
	"txt_goat": "goat",
	"txt_monkey": "monkey",
	"txt_rooster": "rooster",
	"txt_dog": "dog",
	"txt_pig": "pig",

	//Generic Machine Game
	"txt_tickets": "TICKETS",
	"txt_remove_unwanted_tickets": "Please remove the unwanted tickets before submitting.",
	"txt_submit_to_confirm_rebet": "Click Submit button to confirm Rebet.",
	"txt_no_tickets": "You have no running tickets.",
	"txt_running_tickets": "RUNNING TICKETS",
	"txt_choose_bet_type": "Choose bet type to start.",
	"txt_place_bet_amount": "Please place your bet amount first.",
	"txt_add_tickets": "Add Tickets",
	"txt_choose_bet_type_message": "Please choose Bet Type to start.",
	"txt_remove_unwanted_ticket_message": "Please remove the unwanted tickets before submitting.\nClick Submit button to confirm rebet.",
	"txt_rebet_ticket_message": "You still have rebet tickets!\nTouch \"Show\" to see, then touch Submit to send your bets.",
	"txt_drawing_result": "Drawing Result",

	//Shio Balls
	"txt_m29_first": "First",
	"txt_m29_middle": "Middle",
	"txt_m29_last": "Last",

	//Samgong
	"txt_3_pictures": "3 Pictures",
	"txt_any_pictures": "Any Pictures",
	"txt_either_3_picture": "Either 3 Picture",
	"txt_either_any_picture": "Either Any Picture",

	//Gong Ball Jitu
	"txt_gbj_result_message": "To view the live result for the GONG BALL JITU game,  please refer to the GongBall board (left side) on the live streaming.",

	// popup streaming quality
	"txt_popup_streaming_quality": "Please change streaming quality to HD here",

	// new lang for history toto macau
	"txt_action": "Action",

	// bet panel m39
	"txt_m39_red": "Red",
	"txt_m39_blue": "Blue",
	"txt_m39_tie": "Tie",
	"txt_m39_odd": "Odd",
	"txt_m39_even": "Even",
	"txt_m39_low": "Low",
	"txt_m39_high": "High",
	"txt_m39_Odd/Even": "Odd/Even", 
	"txt_m39_Odd/Odd": "Odd/Odd", 
	"txt_m39_Even/Odd": "Even/Odd", 
	"txt_m39_Even/Even": "Even/Even",
	"txt_m39_Low/High": "Low/High", 
	"txt_m39_Low/Low": "Low/Low", 
	"txt_m39_High/Low": "High/Low", 
	"txt_m39_High/High": "High/High",

	// htp m17
	"txt_m17_out-number": "Out Number",
	"txt_m17_4D/3D/2D": "4D/3D/2D",
	"txt_m17_free-plug": "Free Plug",
	"txt_m17_2D-free-plug": "2D Free Plug",
	"txt_m17_plug-dragon": "Plug Dragon",
	"txt_m17_plug-it-in": "Plug it in",
	"txt_m17_middle-edge": "Middle Edge",
	"txt_m17_combination": "Combination", 
	"txt_m17_base": "Base",
	"txt_m17_50-50": "50-50",
	"txt_m17_shio": "Shio",
	"txt_m17_cross": "Cross",
	"txt_m17_flaming-flower": "Flaming Flower",

	// how to play
	"txt_htp_intro": "Introduction",
	"txt_htp_rules": "Game Rules",
	"txt_htp_placing-bet": "PLACING A BET",
	"txt_htp_bet-desc": "BET DESCRIPTION & EXAMPLES",
    "txt_htp_payout": "Payout",
	"txt_htp_rank": "Rank",
	"txt_complete_information": "DETAILED INFORMATION"
};

export default EN;